import {
  SELECTED_ITEMS,
  USERS_DELETE,
  ROLES_DELETE,
  RESET_DELETESTATE,
  DATABASE_USERSUPDATE,
  UNDO_DELETE_USER,
  DELETE_USER,
} from "../constants/constants";

const initialState = {
  selectedItems: [],
  isUsersDeleted: false,
  isRolesDeleted: false,
  isDatabaseUsersBatchEdit: false,
  dataLoaded:false,
  deleteCandidate: null,
  actionType: null,
};

export const selectedItemsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_USER:
      return {
        ...state,
        deleteCandidate: action.payload,
        actionType: DELETE_USER,
      };
    case UNDO_DELETE_USER:
      return {
        ...state,
        deleteCandidate: action.payload,
        actionType: UNDO_DELETE_USER,
      };
    case SELECTED_ITEMS:
      return {
        ...state,
        selectedItems: action.selectedArray,
        isUsersDeleted: false,
        isRolesDeleted: false,
        actionType: null,
        deleteCandidate: null,
      };
    case USERS_DELETE:
      return {
        ...state,
        isUsersDeleted: true,
        selectedItems: action.selectedArray? action.selectedArray : state.selectedItems,
      };
    case ROLES_DELETE:
      return {
        ...state,
        isRolesDeleted: true,
      };
    case DATABASE_USERSUPDATE: {
      return {
        ...state,
        isDatabaseUsersBatchEdit: !state.isDatabaseUsersBatchEdit,
      };
    }
    case RESET_DELETESTATE:
      return {
        ...state,
        isUsersDeleted: false,
        isRolesDeleted: false,
        isDatabaseUsersBatchEdit: false,
      };
    case "SELECTEDITEMS_RESET": {
      return {
        ...state,
        selectedItems: [],
      };
    }
    case "SET_DATA_LOADED": {
      return {
        ...state,
        dataLoaded: action.payload,
      };
    }
    default:
      return state;
  }
};
